import { render, staticRenderFns } from "./ApptSettings.vue?vue&type=template&id=6119997a&"
import script from "./ApptSettings.vue?vue&type=script&lang=js&"
export * from "./ApptSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports